// extracted by mini-css-extract-plugin
module.exports = {"search":"_9400a595a7--search--QpKkG","content":"_9400a595a7--content--hZlYN"};